






















  import { Component, Prop, Mixins } from 'vue-property-decorator';
  import IconCustom from '@/components/lib/IconCustom.vue';
  import inputThemeMixin from '@/mixins/inputThemeMixin';
import { IModalInitData } from '@/entities';

  @Component({
    components: {
      IconCustom
    },
  })
  export default class CheckboxCommon extends Mixins(inputThemeMixin) {
    @Prop() readonly value!: boolean;
    @Prop() readonly description?: string;
    @Prop({ default: false }) readonly easy?: boolean;

    get modal(): IModalInitData {
      return this.$store.state.modal;
    }

    get  getChBxColor(): boolean {
        return this.$store.getters.getCheckboxLabelColor;
      }

    private change(e: any = null): void {
      (this.$refs['native'] as HTMLElement)?.focus();
      if (!this.easy && e) {
        e.stopPropagation()
      }
      this.$emit('input', !this.value);
    }

  }
